<template>  
  <mission-detail-graphics :sciGraph="false" :simuGraph="true" :isleft="isleft" :uiid="uiid" :mission="currentDetailMission.mission.simulation" :tabState="currentDetailMission" />
</template>
<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'
import MissionDetailGraphics from '@/components/mission/MissionDetailGraphics.vue'

@Component({
  name: 'MissionEndSimulationSinglePlots',
  props: {
    isleft:Boolean,
    uiid:{
        type: String,
        required: true
    }
  },
  components:{MissionDetailGraphics}
})
export default class MissionEndSimulationSinglePlots extends Vue {      

    isleft!:boolean
    uiid!:string

    get currentDetailMission(){
      return this.$store.myGetters.currentDetailMission
    }    

  }
</script>